import VisFieldFormView from "./VisFieldFormView";

function VisFieldForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
}) {
  return (
    <VisFieldFormView
      setPrinterData={setPrinterData}
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      submitError={submitError}
    />
  );
}

export default VisFieldForm;
